import { initializeApp } from 'firebase/app';
import {
  getFirestore,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDq28ICaR9_VAhwmZ1okPflf7NRzVz3zgA",
  authDomain: "medcheck26.firebaseapp.com",
  projectId: "medcheck26",
  storageBucket: "medcheck26.firebasestorage.app",
  messagingSenderId: "451459175482",
  appId: "1:451459175482:web:ff8ef94e4067343d261103",
  measurementId: "G-YH924LX3B1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

function createFirestore() {
  try {
    return initializeFirestore(app, {
      localCache: persistentLocalCache({
        tabManager: persistentMultipleTabManager(),
      }),
    });
  } catch {
    return getFirestore(app);
  }
}

export const db = createFirestore();

export const storage = getStorage(app);
export const auth = getAuth(app);

export default app;
